export { default } from './disclaimer-text';
